frappe.provide("jhaudio.checkout");
frappe.provide("erpnext.shopping_cart");
const shopping_cart = erpnext.shopping_cart;

class CartCheckoutExperience {
  /**
   * Initializes the checkout experience
   * @param {*} doc A quotation compatible doctype object.
   */
  constructor(doc) {
    this.doc = doc;
  }

  async init() {
    const me = this;

    this.$spinnerScreen = $('.screen.spinner');
    this.$cartScreen = $('.screen.cart');
    this.$shippingScreen = $('.screen.shipping');
    this.$billingScreen = $('.screen.billing');
    this.$checkoutScreen = $('.screen.checkout');
    this.$shippingRatesContainer = $('.rates-container');
    this.$terms = $('.terms');
    this.$screens = $('.screen');
    this.$confirmPurchaseBtn = this.$checkoutScreen.find('.confirm-purchase');
    this.currentScreen = window.location.hash.replace('#', '').toLowerCase();

    // handle screen navigation
    $('button.purchase').click(function () { location.hash = "#shipping"; });
    $('button.shipping-continue').click(async function () {
      let is_picked = $('#shipping-pickup').is(':checked');
      await frappe.call({
        method: "jhaudio.cart.set_order_shipping_address",
        args: {
          doctype: me.doc.doctype,
          docname: me.doc.name,
          address: me.doc.shipping_address_name,
          company: me.doc.company,
          customer_pick_up: is_picked? 1 : 0,
          shipping_method: me.doc.fedex_shipping_method,
          use_customer_fedex_account: me.doc.use_customer_fedex_account
        },
        freeze: true
      });
      location.hash = "#billing";
    });
    $('button.billing-continue').click(function () { location.hash = "#checkout"; });

    this.$confirmPurchaseBtn.click(this.redirectToGateway.bind(this));

    // initialize shipping and billing address widgets
    this.shippingAddrWidget = new jhaudio.checkout.CartShippingAddressWidget(
      this.$shippingScreen.find('.address-widget'),
      this.$shippingRatesContainer,
      this.$shippingScreen,
      this.doc,
    );

    this.billingAddrWidget = new jhaudio.checkout.CartBillingAddressWidget(
      this.$billingScreen.find('.address-widget'),
      this.$billingScreen,
      this.doc
    );

    this.shippingAddrWidget.on('valid', this.shippingValid.bind(this, true));
    this.shippingAddrWidget.on('invalid', this.shippingValid.bind(this, false));

    this.billingAddrWidget.on('valid', this.billingValid.bind(this, true));
    this.billingAddrWidget.on('invalid', this.billingValid.bind(this, false));

    // taking over this page's hash navigation
    window.addEventListener("hashchange", this.handleHashChange.bind(this));

    // trigger hashchange handler to initialize view.
    this.handleHashChange();

    // show doc's terms and conditions if available
    if ( this.$terms.length > 0 ) {
      this.$terms.show();
    }

    // vanilla cart binds

    $(".cart-items").on("change", ".cart-qty", async function () {
      let row = $(this).closest("tr").data("name");
      let item_code = $(this).data("item-code");
      let qty = $(this).val();
      frappe.freeze();
      shopping_cart.update_cart({
        item_code,
        qty,
        row,
        additional_notes: undefined,
        with_items: 1,
        callback: function (r) {
          window.location.reload();
        }
      });
    });

    // Designer edit button action
    $(".designer-edit").click(async function() {
      window.location.href = `/build?edit=${$(this).attr('data-name')}`;
    });

    $(".btn-coupon-apply").click(function() {
      const code = $(this).siblings('input').val();
      const $btn = $(this);
      me.applyCoupon(code, $btn, '');
    });

    $('input[data-validation="digit"]')
      .on("paste", function(e) {
        if (e.originalEvent.clipboardData.getData('text').match(/[^\d]/))
          e.preventDefault(); //prevent the default behaviour
      })
      .keypress(function(event) {
        return (event.charCode !== 8 && event.charCode === 0 || (event.charCode >= 48 && event.charCode <= 57));
      });
  }

  /**
   * Change screen displayed
   */
  changeScreen($screen) {
    if ($screen && $screen.length > 0) {
      $('html, body').animate({ scrollTop: 0}, "slow", "linear");
      this.$screens.not($screen).removeClass('active');
      $screen.addClass('active');
    }
  }

  /**
   * Watches for hash changes and updates cart screen displays
   */
  handleHashChange() {
    const screen = window.location.hash.replace('#', '').toLowerCase();

    // force a page reloads between screen changes to pickup changes from the server
    if (screen != this.currentScreen) {
      if (screen == "cart") {
        window.location.hash = "";
      }
      this.changeScreen(this.$spinnerScreen);
      window.location.reload();
      return;
    }

    if (!this.doc.items || this.doc.items.length == 0 && screen != "") {
      window.location.hash = "";
      window.location.reload();
    }

    switch (screen) {
      case "cart":
        location.hash = "";
        this.changeScreen(this.$cartScreen);
        break;
      case "shipping": this.changeScreen(this.$shippingScreen); break;
      case "billing": this.changeScreen(this.$billingScreen); break;
      case "checkout": this.changeScreen(this.$checkoutScreen); break;
      default: this.changeScreen(this.$cartScreen); break;
    }
  }

  shippingValid(isValid) {
    console.log("Shipping valid? ", isValid);
    $('button.shipping-continue').prop('disabled', !isValid);
  }

  billingValid(isValid) {
    console.log("Billing valid? ", isValid);
    $('button.billing-continue').prop('disabled', !isValid);
  }

  async applyCoupon(code, $btn, sales_partner) {
    return await frappe.call({
      type: "POST",
      method: "erpnext.shopping_cart.cart.apply_coupon_code",
      btn: $btn,
      args : {
        applied_code : code,
        applied_referral_sales_partner: sales_partner
      },
      callback: function(r) {
        if (r && r.message){
          location.reload();
        }
      }
    });
  }

  async redirectToGateway() {
    const $selectedGateway = this.$checkoutScreen.find('.gateway-list input[type=radio]:checked');

    if ($selectedGateway.length == 0) {
      console.error("No gateway selected!");
      return;
    }

    const selectedGateway = $selectedGateway.val();
    const gatewayAccount = $selectedGateway.attr('data-account');

    if (selectedGateway && gatewayAccount) {
      // If bill me later is enabled
      if (selectedGateway == "billme_later") {
        await frappe.xcall("erpnext.shopping_cart.cart.place_order").then((r) => {
          window.location.href = "integrations/payment-success";
        });

        return;
      }

      const methodUrl = '/api/method/erpnext.accounts.doctype.payment_request.payment_request.make_payment_request';
      window.location.href = `${methodUrl}?dn=${quotation_name}&dt=Quotation&mute_email=1&submit_doc=1&order_type=Shopping Cart&payment_gateway=${gatewayAccount}`;
    } else {
      console.error("Incomplete gateway data")
    }
  }
}

jhaudio.checkout.init = (doc) => {
  jhaudio.checkout.experience = new CartCheckoutExperience(doc);
  return jhaudio.checkout.experience.init();
}
